import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { Container, Tab, Tabs } from "react-bootstrap";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import PreviewRepairNotification from "../../../components/RepairWork/PreviewRepairNotification";

export default function PreviewRepairNotify() {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        history: "แสดงใบแจ้งซ่อม",
        status: "ตรวจสอบสถานะลูกค้า/สาขา",
        product: "ตรวจสอบอายุประกันสินค้า"
      },
      navigated: (navi) =>
        navi && key !== state && navigate(pathname, { state: key })
    });
  };

  useEffect(() => handleChangeTab(state || "history"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Check Customer History Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state || "history"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="history" title="ตรวจสอบประวัติลูกค้า/สาขา">
            <PreviewRepairNotification />
          </Tab>
          <Tab eventKey="status" title="ตรวจสอบสถานะลูกค้า/สาขา"></Tab>
          <Tab eventKey="product" title="ตรวจสอบอายุประกันสินค้า"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
